import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-bottom',
  imports: [TranslatePipe],
  templateUrl: './menu-bottom.html',
  styleUrl: './menu-bottom.css',
})
export class MenuBottom {

}